import { render, staticRenderFns } from "./PostSaleList.vue?vue&type=template&id=535a2a56&scoped=true&"
import script from "./PostSaleList.vue?vue&type=script&lang=js&"
export * from "./PostSaleList.vue?vue&type=script&lang=js&"
import style0 from "./PostSaleList.vue?vue&type=style&index=0&id=535a2a56&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535a2a56",
  null
  
)

export default component.exports